import type { ApexOptions } from "apexcharts";
import "./tooltip.scss";

const labelsStyle = {
  style: {
    fontFamily: "'Inter', sans-serif",
    fontSize: "0.75rem",
    fontWeight: 400,
    colors: "#475467",
  },
};

export const sharedOptions: ApexOptions = {
  legend: {
    show: false
  },
  chart: {
    zoom: {
      enabled: false
    },
    toolbar: {
      show: false,
    },
    animations: {
      enabled: true,
      speed: 400,
      dynamicAnimation: {
        enabled: false,
      }
    },
  },
  tooltip: {
    theme: 'dark',
  },
  yaxis: {
    labels: {
      ...labelsStyle,
      offsetY: 3
    },
  },
};